module.exports = __webpack_public_path__ + "media/images/warsaw-6305b1558fde87cb12a959825dd5acb9.jpg";